/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Typography } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'

import React
 from 'react'
import { useUpdateForm } from '../../../context/UpdateFormProvider';

const nurse_performance_key_compare = ["Foot_Forms", "Eye_Forms", "total_referred_tests", "Rejected_forms"]

const UpdateCell = ({row, endPoint, isRoute=false, fullRow, keys}) => {
  const navigate = useNavigate();
  const {setUpdateFormValues} = useUpdateForm()
    const handleUpdate = ()=>{
        setUpdateFormValues(row)
        setTimeout(()=>navigate(`${endPoint}-list/add`), 100)
    }
    const handleView = ()=>{
      setUpdateFormValues(fullRow);
      if(endPoint === "/master_admin_dashbord/nurse_detail_data" && keys==="nurses_first_name"){
        setTimeout(()=>navigate(`/nurses-list/view`), 100)
      }else if(endPoint === "/master_admin_dashbord/nurse_detail_data" && nurse_performance_key_compare.includes(keys)){
        setTimeout(()=>navigate(`${endPoint}/view?${keys}=true&nurses_id=${fullRow.nurses_id}`), 100)
      }
      else {
        setTimeout(()=>navigate(`${endPoint}-list/view`), 100)
      }
    }
    
  return (
    <>
    {isRoute ? <Typography variant='subtitle1' sx={{ p:0, fontSize: "12px", cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}} onClick={handleView}>{row}</Typography> :
    <Button size='small' onClick={()=>handleUpdate(row)} color="warning" sx={{fontSize: "10px", textWrap:"nowrap"}}>Update</Button>}
    </>
  )
}

export default UpdateCell